import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import PortfolioSizeHeader from "./portfolio/PortfolioSizeHeader";
import PortfolioSizeContainer from "./portfolio/PortfolioSizeContainer";

interface PortfolioSizeStepProps {
  onContinue: () => void;
}

const PortfolioSizeStep = ({ onContinue }: PortfolioSizeStepProps) => {
  return (
    <div className="space-y-8">
      <PortfolioSizeHeader />
      
      <div className="space-y-8">
        <PortfolioSizeContainer />

        <div className="pt-6">
          <Button size="lg" className="w-full max-w-md" onClick={onContinue}>
            Continue
            <ChevronRight className="ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PortfolioSizeStep;